import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import HomePageBG from '../assets/HomepageBG.jpg';
import { ROUTES } from '../constants/routes';
import { NewUserPage } from '../pages/user/NewUserPage';

import { NavbarLoading } from './NavbarLoading';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, isAuthenticated, loading, initialAuthCheckDone } = useSelector(
    (state) => state.auth
  );

  if (loading || !initialAuthCheckDone) {
    return (
      <div>
        <NavbarLoading src={HomePageBG} pageName={'Sustainable Land Initiative'} />
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
          <MoonLoader color="#000" size={50} />
        </div>
      </div>
    );
  }

  if (initialAuthCheckDone && !isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  if (initialAuthCheckDone && isAuthenticated && user?.newUser) {
    return <NewUserPage />;
  }
  if (initialAuthCheckDone && requireAdmin && isAuthenticated && user?.role !== 'admin') {
    return <Navigate to={ROUTES.HOME} />;
  }

  return children;
};

export { ProtectedRoute };
